(function () {
    "use strict";

    /**
     * A widget for adding files to an object.
     * The file is read into memory and added to the list owned by another object.
     * When the file is read a callback is invoked.
     * REMARK: We cannot use ng-attr-multiple to dynamically set the multiple attribute.
     * For a select-input angularjs even throws an error (documented at https://docs.angularjs.org/error/$compile/selmulti)
     * Additionally input=file was never supported in angular 1.x
     */
    angular.module("app").component("habilFilePickerWidget", {
        // UI Adapted from https://css-tricks.com/drag-and-drop-file-uploading/
        templateUrl: "@/upload/filePickerWidget.html",
        bindings: {
            fileType: "@",
            onFileSelected: "&",
            allowMultiple: "=?",
            allowExtensions: "@"
        },
        controller: FilePickerWidgetController
    });

    FilePickerWidgetController.$inject = ["$scope", "controllerDecorator", "FileUploaderFactory"];
    function FilePickerWidgetController($scope, controllerDecorator, FileUploaderFactory) {
        const $controller = this;

        const privateStore = {
            Attachments: []
        };

        controllerDecorator.Decorate($controller, []);

        /**
         * Invokes the onFileSelected callback
         */
        function executeCallback() {
            if (privateStore.Attachments.length === 0)
                return;

            try {
                if (!angular.isFunction($controller.onFileSelected))
                    return;

                $controller.onFileSelected({ attachments: privateStore.Attachments });
            }
            finally {
                // Reset the widget to avoid double uploads
                privateStore.Attachments = [];
            }
        };

        // We MUST use the fileUploader to be able to use the nv-file-drop and nv-file-over directives
        $scope.fileUploader = FileUploaderFactory.CreateFileUploader(null, {
            onSuccessItem: (_f, attachment) => {
                attachment.TypeCode = $controller.fileType;
                privateStore.Attachments.push(attachment);

                $("input[type=file][nv-file-select]").val("");
            },
            onErrorItem: onErrorItem,
            onCompleteAll: executeCallback
        });

        $controller.$onInit = function () {
            $scope.fileUploader.queueLimit = $controller.allowMultiple ? 10 : 1;

            if (angular.isString($controller.allowExtensions)) {
                FileUploaderFactory.AddExtensionFilter($scope.fileUploader, $controller.allowExtensions.toLowerCase().replace(/\./g, "").split(","));
            }
            else {
                $controller.allowExtensions = ".pdf";
            }
        };

        function onErrorItem(fileItem, _response, _status, _headers) {
            $controller.ShowError(getErrorMessage(fileItem?.error));

            function getErrorMessage(error) {
                const baseMessage = $controller.getTranslation("Shared_Something_Went_Wrong");
                if (!error || !error.name)
                    return baseMessage;

                return `${baseMessage} [${error.name}]`;
            }
        };
    };
})();